import { curry } from 'lib/util'
import usPowerValues from '@model/xEcoApm/collection/usPower'

/**
 * Returns the list of available ultrasound power values.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 * @returns the list of frequencies
 */
const listUsPowerValues = (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: Gaia.PlatformEvent,
): { key: number, value: string }[] => usPowerValues

export default curry(listUsPowerValues)
